import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Button from "../../../../base/reusables/button/Button";
import AppStore from "../../../../base/stores/AppStore";
import lessonStore from "../../lessonStore";
import style from "./ApproveActions.module.css";
import { observer } from "mobx-react";
import { Id, LessonDI } from "../../types";

const ApproveActions = ({ lessonId }: { lessonId: number | undefined }) => {
   const navigate = useNavigate(); 
  const { t } = useTranslation();
  const clickHandler = async (toApprove: boolean) => {
    try {
      AppStore.incrementLoadingProcedure();
      if(lessonId) {
        toApprove
        ? await lessonStore.approveLesson(lessonId, AppStore.isMobileResolution)
        : await lessonStore.deleteLesson(lessonId, AppStore.isMobileResolution);
        navigate(AppStore.lessonsRoute);
      }
      
    } catch (error) {
      console.error(error);
      alert(error);
    } finally {
      AppStore.decrementLoadingProcedure(); 
    }
  };
  return (
    <section className={style.wrapper}>
      <Button onClick={() => clickHandler(true)}>
        {t("Lesson-view-approve")}
      </Button>
      <Button variant="empty" onClick={() => clickHandler(false)}>
        {t("Lesson-view-cancel-and-delete")}
      </Button>
    </section>
  );
};

export default observer(ApproveActions);
